<template>
    <div>
        <v-row>
            <v-col class="pa-0">
                <search-panorama-insurers
                    v-model="insurerFilters.insurerCodes"
                    :insurers="insurers"
                />
            </v-col>
            <v-col class="pa-0">
                <search-panorama-guarantess
                    v-model="insurerFilters.guarantees"
                    :annotationOptions="annotationOptions"
                    :displayedSubjectsByType="displayedSubjectsByType"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0">
                <search-panorama-insurance-types
                    v-model="insurerFilters.insuranceType"
                    :annotationOptions="annotationOptions"
                />
            </v-col>
            <v-col class="pa-0">
                <search-panorama-des v-model="insurerFilters.des" />
            </v-col>
        </v-row>
        <search-panorama-convention-csp v-model="insurerFilters.csps" />
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import SearchPanoramaInsurers from "./SearchPanoramaInsurers.vue";
import SearchPanoramaGuarantess from "./SearchPanoramaGuarantess.vue";
import SearchPanoramaInsuranceTypes from "./SearchPanoramaInsuranceTypes.vue";
import SearchPanoramaDes from "./SearchPanoramaDes.vue";
import SearchPanoramaConventionCsp from "./SearchPanoramaConventionCsp.vue";

export default {
    props: ["value", "insurers", "annotationOptions", "displayedSubjectsByType"],
    components: {
        SearchPanoramaInsurers,
        SearchPanoramaGuarantess,
        SearchPanoramaInsuranceTypes,
        SearchPanoramaDes,
        SearchPanoramaConventionCsp,
    },
    data() {
        return {
            insurerFilters: {
                insurerCodes: this.value.insurerCodes,
                guarantees: this.value.guarantees,
                insuranceType: this.value.insuranceType,
                des: this.value.des,
                csps: this.value.csps,
            },
        };
    },
    mounted() {
        EventBus.$on("clearPanoramaFilters", () => {
            this.insurerFilters = {
                insurerCodes: null,
                guarantees: null,
                insuranceType: null,
                des: null,
                csps: null,
            };
        });
    },
    watch: {
        insurerFilters: {
            handler(_insurerFilters) {
                this.$emit("input", _insurerFilters);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="sass"></style>
